import { Modal } from "react-bootstrap"
import { useMutation, useQueryClient } from "react-query"
import { toast } from "react-toastify"

import { updateCourseMerchant } from "../../../../../models/courses/courses"
import CourseMerchantForm from "./CourseMerchantForm"


const EditCourseMerchantModal = ({ courseId, courseMerchant, show, onHide }) => {
    const queryClient = useQueryClient()
    const { mutate, isLoading } = useMutation(data => updateCourseMerchant(courseId, courseMerchant.merchant_id, data), {
        onSuccess: () => {
            toast.success('Success')
            queryClient.invalidateQueries([`course-${courseId}-merchants`])
            onHide()
        },
        onError: error => toast.error(error?.response?.data?.message)
    })

    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Course Merchant</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CourseMerchantForm
                    courseMerchant={courseMerchant}
                    onSubmit={data => mutate(data)}
                    submitLoading={isLoading}
                />
            </Modal.Body>
        </Modal>
    )
}

export default EditCourseMerchantModal